module.exports = __webpack_public_path__ + "static/media/marketplace.15510cd7.jpg";